import { createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { IStatusUpdate } from '@vivli/shared/infrastructure/interface';

interface IStatusUpdateContext {
    submitStatusUpdate(): void;
    isSubmittingForm?: boolean;
    formApi?: UseFormReturn<IStatusUpdate>;
    isFormDirty?: boolean;
    isFormValid?: boolean;
}

export const StatusUpdateContext = createContext<IStatusUpdateContext>(null);

export const useStatusUpdateContext = () => useContext(StatusUpdateContext);
